import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import 'animate.css'
import './assets/css/feature.css'
import './assets/scss/style.scss'
import './assets/tailwind.css'

import 'bootstrap'
import i18n from './i18n'
const app = createApp(App)

createApp(App).use(router).use(i18n).mount('#app')
